import { Component, OnInit } from '@angular/core';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';

@Component({
  selector: 'astrea-policy-privacy',
  templateUrl: './policy-privacy.component.html',
  styleUrls: ['./policy-privacy.component.scss']
})
export class PolicyPrivacyComponent implements OnInit {

  constructor(
    private seo: SeoMetadataService,
  ) { }

  ngOnInit(): void {
    this.setMetadata();
  }

  setMetadata(): void {
    this.seo.setMetadata({
      title: 'Políticas de privacidad',
      description: 'Políticas de privacidad de los servicios de la Editorial Astrea.',
      relativeUrl: '/policy'
    });
  }

}
